import React, { useState } from "react";
import { PaymentPlansModal } from "../components/paymentPlansModal";

const usePricingModal = (isFreeUser = true) => {
  const [isShowing, setIsShowing] = useState(false);

  const togglePricingModal = () => setIsShowing(!isShowing);

  const modalComponent = (
    <PaymentPlansModal
      isOpen={isShowing}
      onClose={togglePricingModal}
      isFreeUser={isFreeUser}
    />
  );

  return { modalComponent, togglePricingModal };
};

export default usePricingModal;
